import React, {Component} from 'react';
import { Icon, InputItem } from 'antd-mobile';
import Remark from './remark';
import PropTypes from 'prop-types';
import './index.less';

const isMobile = /Android|iPhone|iPod|iPad/i.test(navigator.userAgent);
const isIOS =/iphone|iPhone|ipad|ipod|ios/i.test(navigator.userAgent);
const isPC = !isMobile;
class Select extends Component{
    constructor(props) {
        super(props);
        this.state = {
          value: null,
          isShow: false,
          label: $st('请选择'),
          serchKey: ''
        };
        this.setLabel = this.setLabel.bind(this);
      }
    resetChildField = (form, child_node)=>{
        let names = child_node && child_node.map(item =>{
            return item.api_name;
        });
        names && form.resetFields(names);
        
        child_node && child_node.forEach(item =>{
            this.resetChildField(form, item.child_node);
        });
    }
    onChange = (event)=>{
        let onChange = this.props.onChange;
        onChange && onChange(event.target.value);
        // 如果存在子节点
        let {child_node, form} = this.props;
        this.resetChildField(form, child_node);
    }
    
    showSelect = (flag) => {
        this.setState({
            serchKey: '',
        })
        if(flag){
            return
        }else{
            this.setState({isShow: !this.state.isShow})
        }
    }

    selectItem = (label, value, e, changeIsShow = true) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        this.setState({
            label: label,
            serchKey: '',
            isShow: changeIsShow ? !this.state.isShow : this.state.isShow
        })
        let onChange = this.props.onChange;
        onChange && onChange(value);
        // 如果存在子节点
        let {child_node, form} = this.props;
        this.resetChildField(form, child_node);
    }
    hideSelect = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        if(e.target&&e.target.className === 'form-select-li' || e.target.className.indexOf('form-select-wrapper') > -1) {
            this.setState({isShow: false})
        }
    }
    hideSelectFromMask = (e) => {
        this.setState({isShow: false})
    }
    setLabel(label) {
        this.setState({label:label})
    }
    onItemInput(e) {
        let me = this;    //借助闭包
        if(this.timer){
            clearTimeout(this.timer) 
        }
        this.timer = setTimeout(() => {
            me.setState({
                serchKey: e
            })
        }, 500) // 简化写法
    }
    formatOptions(options) {
        let serchKey = this.state.serchKey
        return options.map((item) => {
            if(item.label.indexOf(serchKey) > -1) {
                item.isShowItem  = true
            }else{
                item.isShowItem  = false
            }
            return item
        })
    }
    onFocus(e) {
        if(isIOS) {
            setTimeout(() => {
                window.scrollTo({ 
                    top: document.getElementsByClassName('App')[0].offsetHeight - window.innerHeight, 
                    behavior: "smooth" 
                });
                document.getElementsByClassName('form-select-ul')[0].style['height'] = '253px'  
            },300)
            
        }
    }
    onBlur(e) {
        if(isIOS) {
            document.getElementsByClassName('App')[0].style.transform = 'none'
            window.scrollTo(0,this.scrollTopValue)
            document.getElementsByClassName('form-select-ul')[0].style['height'] = 'auto'
        }
    }
    componentWillMount(){
        let { options,value} = this.props;
        let default_option = options.find(item => {
            return item.value === value
        })
        if(default_option){
            this.setLabel(default_option.label)
            // this.setState({lable:default_option.label})
        }
    }

    componentDidUpdate(cur,old) {
        //移动端有单选样式时禁止后面的滚动条
        if(old.isShow !== this.state.isShow && isMobile) {
            if(this.state.isShow) {
                if(isIOS) {
                    this.scrollTopValue = document.documentElement.scrollTop || window.pageYOfset || document.body.scrollTop
                }
                document.documentElement.style.overflow = "hidden";
            }else{
                if(isIOS) {
                    window.scrollTo(0,this.scrollTopValue)
                }
                document.documentElement.style.overflow = "scroll";
            }
        }
    }

    render(){
        let { form, options, value, error, is_readonly, api_name, type, is_required, is_tiled } = this.props;
        let isTiled = is_tiled === undefined ? false : is_tiled;
        const { getFieldError, getFieldProps } = form;
        options && (options = this.formatOptions(options))
        options = options.filter(option=>{
            return option&&!option.not_usable;
        })

        var me = this;
        // option items
        
        let classes = error ? 'select-error': '';
        let other_item = options.find((item) => {
            return item.value === 'other';
        });
        let errorText = getFieldError(api_name);

        let default_option = options.find(item => {
            return item.value === value
        })

        if (!default_option) {
            value = '';
        }
        let props_options = {
            initialValue: value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }],
            }]
        }
        let fieldProps = {...getFieldProps(api_name, { ...props_options })}
        let tempProps = {
            type: 'text',
            placeholder: $st('请输入'),
            className: 'select-ul-search'
        }
        let optionItems = options.map((option,i)=>{
            let flag = false
            if(option.value === value) {
                flag = true
            }
            return (
            option.isShowItem && <li key={option.value} value={option.value} className="form-select-li" onClick={(e) => {this.selectItem(option.label,option.value,e)}}>
                {default_option && default_option.label ? ((flag||(default_option.label == option.label))?
                    <Icon type='check' className="select-item-icon" />:''):
                    (fieldProps&&fieldProps.value)?
                    ((flag||(me.state.label == option.label))?
                    <Icon type='check' className="select-item-icon" />:''):''}{option.label}
            </li>
            )
        });
        return (
            <div style={{ "position": "relative" }}>
                {!isTiled && <div>
                    <div className="form-select-wrap">
                    <div className="select-wrap" onClick={() => {this.showSelect(is_readonly)}}>
                        {<div className={is_readonly ? 'form-select form-select-readonly' : 'form-select'}>
                            {<p className='form-select-p'>
                                {
                                    type == 'true_or_false'? this.state.label : 
                                        (default_option && default_option.label) ? default_option.label:
                                             fieldProps && fieldProps.value ? this.state.label:
                                                <span style={{'color':'#999'}}>{$st("请选择")}</span>
                                }
                            </p>}
                        </div>}
                        
                        {/* <Icon type='down' className="select-icon" /> */}
                    </div>
                    {value === 'other' && (other_item && !is_readonly && <Remark {...other_item} api_name={api_name + '__o'} form={form} /> || <div className="remark-wrap">
                        <InputItem disabled placeholder={$st('请输入多选备注')} />
                    </div>)}
                    {errorText && <div className="input-error">{errorText}</div>}
                    </div>
                {
                    this.state.isShow && isPC && 
                    <div onClick={(e) => this.hideSelectFromMask(e)} className="form-select-box-mask"></div>
                }
                {
                    this.state.isShow && 
                    // 单选到底的时候加个底距离
                    <div className="form-select-box"> 
                        <div className={isPC ? "form-select-wrapper form-select-wrapper_PC" : "form-select-wrapper form-select-wrapper_Mobile"} onClick={(e) => this.hideSelect(e)}>
                            <ul className="form-select-ul">
                            <InputItem {...tempProps} data-type="search" onChange={this.onItemInput.bind(this)} onBlur={this.onBlur.bind(this)} onFocus={this.onFocus.bind(this)}></InputItem>
                                {type !== 'true_or_false' && 
                                    <li onClick={(e) => {this.selectItem($st('请选择'),'',e)}} className="form-select-li">{(default_option&&!default_option.label)||!default_option&& <Icon type='check' className="select-item-icon" />}{$st("请选择")}</li>}
                                {optionItems}
                            </ul>
                        </div>
                    </div>
                }
                </div>
                }
                {isTiled && <div className='form-select-tiled'>
                    {options.map(i => (
                        <div className='form-select-item' key={i.value}><input type="radio" disabled={is_readonly} name={api_name} value={i.value} checked={value == i.value} className='form-select-radio' onChange={(e) => {this.selectItem(i.label,i.value,e, false)}}
                        /><span>{i.label}</span>
                            {i.value === 'other' && (
                                other_item.value === value
                                ? <Remark {...other_item} api_name={api_name + '__o'} form={form} is_readonly={is_readonly}/>
                                : (<div className="remark-wrap">
                                    <InputItem disabled placeholder={$st('请输入单选备注')} />
                                </div>)
                                )
                            }
                        </div>
                    ))}
                    {errorText && <div className="input-error">{errorText}</div>}
                </div>}
                
            </div>
        )
    }
}
Select.propTypes = {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func
}
export default Select;



// WEBPACK FOOTER //
// ./src/form/select/select.js